export default "__VITE_ASSET__faa251ca__"